import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { getDealsAssignedToCIUsers, getEntityByPdtAndServices } from "http/UAM/userDashboardWidget.helper";
import NoDataChart from "pages/EntityMoreInformation/NoDataComponent";
import { decryptedValue } from "common/utility";

const GetEntityByPdtAndServices = ({ userType }) => {

  const [data, setData] = useState([]);
  const [showStatus, setShowStatus] = useState(true)
  const [type, setType] = useState("Product");
  const user = decryptedValue(localStorage.getItem("user"));
  useEffect(() => {
    getEntityByPdtAndServices({ type, user }).then((res) => {
      if (res.status) {
        setData(res.data.data);
        setShowStatus(true)
      } else {
        setShowStatus(false)
        setData([]);
      }
    });
  }, [type]);


  const xAxisdata = data?.map((financier) => `${financier.name}`);
  while (xAxisdata.length < 6) {
    xAxisdata.push(" ")
  }

  const options = {
    toolbar: {
      show: true,
      tools: {
        download: false,
      },
    },
    chart: {
      type: "bar",
      height: data.length > 6 ? data.length * 50 : 300, // 70px per item, 6 items max visible
    },
    plotOptions: {
      bar: {
        horizontal: true,
        endingShape: "flat",
        barHeight: '50%',
        columnWidth: '50%',
        borderRadius: 0,
        dataLabels: {
          position: "center",
        },
      },
    },
    colors: [
      function ({ dataPointIndex }) {
        const colors = [
          'rgb(52, 195, 143)',
          'rgb(85, 110, 230)',
          'rgb(244, 106, 106)',
          '#f1b44c',
          '#50a5f1',
          '#0174BE',
        ];
        return colors[dataPointIndex] || '#0174BE';
      },
    ],
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      title: {
        text: "Product",
      },
      categories: xAxisdata,
      style: {
        fontSize: '16.5px',
        color: '#333',
        background: 'transparent',
        maxWidth: 300,
        overflow: 'ellipsis',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
    yaxis: {
      // title: {
      //   text: 'Count'
      // }
    },
    fill: {
      opacity: 2,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " counts";
        },
      },
    },
  };
  const handleFilterChange = (e) => {
    setType(e.target.value);
  };

  const series = [
    {
      name: '',
      data: data?.map((entity) => parseInt(entity.count, 10)),
    },
  ];

  return (
    <Card>
      {showStatus ? 
      <CardBody>
          <Row className='mb-2 custom-border'>
            <Col lg='6' sm='6'>
              <h4 className='card-title mb-2 custom-title'>Deals By {type || ''}s</h4>
            </Col>

            <Col lg='6' sm='6'>
              <select
                className="form-select"
                id="filterOptions"
                value={type}
                onChange={handleFilterChange}
                style={{ width: '90%' }}
              >
                <option value="Product">Products</option>
                <option value="Product Type">Product Types</option>
                <option value="Sub Product">Sub Product</option>
              </select>
            </Col>
          </Row>
        <div style={{ maxWidth: "100%" }}>

        </div>
        <div style={{ maxWidth: '100%', maxHeight: '300px'}} className='vertical-scroll'>
          <style>
            {`
              ::-webkit-scrollbar {
                width: 6px;
              }
              ::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 3px;
              }
              ::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 3px;
              }
              ::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
              div::-webkit-scrollbar {
                width: 6px;
              }
              div::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 3px;
              }
              div::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 3px;
              }
              div::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
            `}
          </style>
          <ReactApexChart
            options={options}
            series={series}
            type="bar"
            height={data.length > 6 ? data.length * 50 : 300}
          />
        </div>
      </CardBody>
        : <NoDataChart title='No Information Found' subtitle="No Product Group Found" />}
    </Card>
  );
};

export default GetEntityByPdtAndServices;
